import { render } from "./teachResearchMenu.vue?vue&type=template&id=083889c2&scoped=true"
import script from "./teachResearchMenu.vue?vue&type=script&lang=js"
export * from "./teachResearchMenu.vue?vue&type=script&lang=js"

import "./teachResearchMenu.vue?vue&type=style&index=0&id=083889c2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083889c2"]])

export default __exports__